import React from 'react';
import { Trophy, Target, Users, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ProgressCard } from '../../components/student/ProgressCard';
import { ConsistencyStreak } from '../../components/student/ConsistencyStreak';
import { MetricDisplay } from '../../components/student/MetricDisplay';
import { EngagementCard } from '../../components/student/EngagementCard';
export function StudentHome() {
  const navigate = useNavigate();
  return <div className="space-y-6 pb-24 md:pb-0" data-id="element-462">
      <header className="flex justify-between items-center mb-2" data-id="element-463">
        <div data-id="element-464">
          <h1 className="text-2xl font-bold text-[var(--secondary)]" data-id="element-465">
            Olá, Carlos!
          </h1>
          <p className="text-gray-500 text-sm" data-id="element-466">Vamos treinar hoje?</p>
        </div>
        <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1" data-id="element-467">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-468"></div>
          ACADEMIA ABERTA
        </div>
      </header>

      {/* Hero Section */}
      <section className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-469">
        <div className="md:col-span-2" data-id="element-470">
          <ProgressCard data-id="element-471" />
        </div>
        <div className="md:col-span-1" data-id="element-472">
          <ConsistencyStreak days={12} isActive={true} data-id="element-473" />
        </div>
      </section>

      {/* Quick Metrics */}
      <section className="grid grid-cols-2 gap-3" data-id="element-474">
        <MetricDisplay icon={Target} label="Frequência" value="85%" subtext="Últimos 30 dias" color="bg-blue-50 text-blue-600" data-id="element-475" />
        <MetricDisplay icon={Zap} label="Pontos" value="2.450" subtext="Nível Ouro" color="bg-yellow-50 text-yellow-600" data-id="element-476" />
      </section>

      {/* Engagement Actions */}
      <section className="space-y-3" data-id="element-477">
        <h3 className="font-bold text-gray-800 text-lg" data-id="element-478">Destaques</h3>

        <EngagementCard title="Hall da Fama" description="Veja os destaques do mês na academia" icon={Trophy} color="bg-yellow-500" onClick={() => navigate('/student/hall-of-fame')} badge="Novo" data-id="element-479" />

        <EngagementCard title="Desafios Ativos" description="Complete o desafio de Verão e ganhe pontos" icon={Target} color="bg-[var(--primary)]" onClick={() => {}} data-id="element-480" />

        <EngagementCard title="Meu Time" description="Em breve: treine em grupo e compita" icon={Users} color="bg-purple-500" onClick={() => {}} data-id="element-481" />
      </section>
    </div>;
}